import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import Projects from './views/Projects.vue'
import Team from './views/Team.vue'
import Admin from './views/Admin.vue'
import Profile from './views/Profile.vue'
import UpdateProfile from './views/UpdateProfile.vue'
import Upload from './views/Upload.vue'
import AddActivity from './views/AddActivity.vue'
import Person from './views/Person.vue'
import Newhrd from './views/Newhrd.vue'
import Prospect from './views/Prospect.vue'
import Trainers from './views/Trainers.vue'
import AdminGuide from './views/AdminGuide.vue'
import {
  db,
  auth
} from '@/fb'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/team',
      name: 'team',
      component: Team,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uprofile',
      name: 'uprofile',
      component: UpdateProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: AddActivity,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/person',
      name: 'person',
      component: Person,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/addhrd',
      name: 'addhrd',
      component: Newhrd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/prospect',
      name: 'prospect',
      component: Prospect,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/trainers',
      name: 'trainers',
      component: Trainers,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/adminguide',
      name: 'adminguide',
      component: AdminGuide,
      meta: {
        requiresGuest: true
      }
    }

  ]
});

//Nav Guards
router.beforeEach((to, from, next) => {
  //check for requird auth guard
  const record = to.matched.find(record => record.meta.cookies && !hasCookies(record.meta.requiresAuth));
  const guest = to.matched.find(record => record.meta.cookies && !hasCookies(record.meta.requiresGuest));
  if (auth.currentUser) {
    if (record) {
      next({
        path: record.meta.redirect || '/'
      });
    } else {
      next();
    }
  } else {
    if (guest) {
      next({
        path: record.meta.redirect || '/'
      });
    } else {
      next();
    }
  }

});
export default router;